import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import StudentDashboardPage from './studentDashboard/StudentDashboardPage'
import { Navigate, Route, Routes } from 'react-router-dom'
import CoachDashboardHome from './coachDashboard/CoachDashboardHome'
import CoachingDashboard from './coachDashboard/CoachingDashboard'
import BusinessDashboard from './coachDashboard/business-dashboard/BusinessDashboard'
import CoachDashboard from './coachDashboard/CoachDashboard'

const DashboardPage = () => {
  const user = useSelector(state => state.user.current_user)

  switch (user.type) {
    case 'Admin':
      return <Navigate to='/communities' replace />
    case 'Student':
      return <StudentDashboardPage />
    case 'Coach':
      return (
        <Routes>
          <Route path='/*' element={<CoachDashboard />}>
            <Route index element={<Navigate to='home' replace />} />

            <Route path='home' element={<CoachDashboardHome />} />
            <Route path='coaching' element={<CoachingDashboard />} />
            <Route path='business' element={<BusinessDashboard />} />
            <Route path='*' element={<Navigate to='/' replace />} />
          </Route>
        </Routes>
      )
    default:
      return null
  }
}

export default DashboardPage
